<template>
  <div class="c-order-util-box">
    <div class="left-box">
      <!-- D: mo 전용 -->
      <div class="text-item only-mo">
        <a href="#">
          <strong> 전체주문 : </strong>
          <span> {{ data.biz1.totalCount }}건 </span>
        </a>
      </div>
      <!-- // D: mo 전용 -->
      <div class="text-item">
        <!-- D: pc 전용 -->
        <strong class="only-pc"> 주문내역 : </strong>
        <!-- // D: pc 전용 -->
        <span>
          {{ data.biz1.search.searchDateSt }} ~
          {{ data.biz1.search.searchDateEd }}
        </span>
      </div>
    </div>
    <div class="right-box">
      <!-- MEMO: 오픈이후 주석 해제
      <div class="c-select type-medium">
        <select name="" id="">
          <option value="">2024</option>
          <option value="">2025</option>
          <option value="">2026</option>
        </select>
      </div>
      <button type="button" class="c-util-button type-line-black">
        <i class="c-icon icon-pdf size-medium"></i>
        <span>유해화학물질신고</span>
      </button>
      -->
    </div>
  </div>
  <div class="line-box">
    <!-- D: 주문내역 현황 -->
    <div class="c-process-order">
      <template v-if="data.biz1.list.length > 0">
        <ul>
          <!-- D: pc 전용 -->
          <li class="only-pc">
            <a href="" @click.prevent="changeStatusCd('')">
              <span class="step-circle">
                <em>{{ data.biz1.totalCount }}</em>
              </span>
              <span class="text">전체주문</span>
            </a>
          </li>
          <!-- // D: pc 전용 -->
          <li
            v-for="(item, index) in data.biz1.list"
            :key="index"
            :class="{ 'small-text': isLargeNumber(item.statCnt) }"
          >
            <a
              href="javascript:void(0);"
              @click.prevent="changeStatusCd(item.cdVl)"
            >
              <span class="step-circle">
                <em>{{ item.statCnt }}</em>
              </span>
              <span class="text">{{ item.cdNm }}</span>
            </a>
          </li>
        </ul>
      </template>
    </div>
  </div>
</template>
<script setup name="orderHistoryTab">
import { api } from "@/plugins/api";
import { computed, inject, onMounted, onUnmounted, reactive } from "vue";
import * as cmUtil from "@/utils/cmUtil.js";
import * as store from "@/store";

const url = inject("url_prefix");

const todayDate = computed(() => {
  const now = new Date();
  const options = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  };
  return now.toLocaleDateString("en-CA", options);
});
const data = reactive({
  biz1: {
    search: {
      searchDateSt: "" /* 시작 주문일자 */,
      searchDateEd: "" /* 끝 주문일자 */,
    },
    list: [],
    totalCount: 0,
  },
});

onMounted(() => {
  pageInit();
});

async function pageInit() {
  store.useOrderListStatusStore().setOrderListTabIdx(0);
  await dateCalculation("month");
  await getOrderListByOrderCount();
  await getOrderHistoryStatusList();
}

// 전체주문 개수
async function getOrderListByOrderCount() {
  const res = await api.get(`${url}/order/selectOrderListByOrderCount`, {
    params: data.biz1.search,
  });
  data.biz1.totalCount = res.data.totalCount;
}

// 주문상태 개수
async function getOrderHistoryStatusList() {
  const res = await api.get(`${url}/order/selectOrderStatusCount`, {
    params: data.biz1.search,
  });
  data.biz1.list = res.data;
}

// 주문상태 클릭
function changeStatusCd(statusCd) {
  store.useOrderListStatusStore().setOrderListTabIdx(0);
  store.useOrderListStatusStore().setOrderListStatusCd(statusCd);
}

// 검색 기간 계산
async function dateCalculation(period) {
  const today = new Date();
  let resultDate = new Date(today);
  switch (period) {
    case "week":
      resultDate.setDate(today.getDate() - 6);
      break;
    case "month":
      resultDate.setDate(today.getDate() - 29);
      break;
    case "half-year":
      resultDate.setDate(today.getDate() - 179);
      break;
    case "year":
      resultDate.setDate(today.getDate() - 364);
      break;
    default:
      await cmUtil.alert("알 수 없는 기간입니다.");
      return null;
  }

  // YYYY-MM-DD 형식으로 변환
  const options = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
  };
  resultDate = resultDate.toLocaleDateString("en-CA", options);
  data.biz1.search.searchDateSt = resultDate;
  data.biz1.search.searchDateEd = todayDate.value;
}

const isLargeNumber = (numStr) => {
  const numWithoutComma = numStr.replace(/,/g, "");
  return Number(numWithoutComma) >= 1000;
};

onUnmounted(() => {
  store.useOrderListStatusStore().setOrderListStatusCd("");
});
</script>
